import type { FunctionComponent } from "react";

import BottomLeftStars from "./bottom-left-stars.png";
import BottomRightStars from "./bottom-right-stars.png";
import {
  BottomLeftStarsContainer,
  BottomRightStarsContainer,
  Container,
  TopLeftStarsContainer,
  TopRightStarsContainer,
} from "./styles";
import TopLeftStars from "./top-left-stars.png";
import TopRightStars from "./top-right-stars.png";

export const Stars: FunctionComponent = () => (
  <Container>
    <TopLeftStarsContainer>
      <img src={TopLeftStars.src} />
    </TopLeftStarsContainer>
    <TopRightStarsContainer>
      <img src={TopRightStars.src} />
    </TopRightStarsContainer>
    <BottomLeftStarsContainer>
      <img src={BottomLeftStars.src} />
    </BottomLeftStarsContainer>
    <BottomRightStarsContainer>
      <img src={BottomRightStars.src} />
    </BottomRightStarsContainer>
  </Container>
);

Stars.displayName = "Stars";
